module.exports = __webpack_public_path__ + "static/langchain-logo-hover-d56a23d865061d9cb05efae830604619.png";